import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "8", cy: "21", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "19", cy: "21", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "ShoppingCart";
const ShoppingCart = memo(themed(Icon));
export {
  ShoppingCart
};
//# sourceMappingURL=shopping-cart.js.map
